import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=2b8ca65c&scoped=true&"
import script from "./TopNavBar.vue?vue&type=script&lang=js&"
export * from "./TopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=2b8ca65c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ca65c",
  null
  
)

export default component.exports